<template>
  <el-dialog title="离职" :visible.sync="formVisible" width="900px" :close-on-click-modal="false">
    <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="110px">
      <ul class="cssNav">
        <li v-for="(item,index) in ulList" :key="index" :class="{'active': item.id === tabType}" :style="{'width':ulList.length==2?'50%':ulList.length==3?'33%':'25%'}">{{item.text}}</li>
      </ul>
      <div style="padding-left: 40px;margin-bottom: 20px;">离职需要把区域，团队，客户归属新的老师</div>
      <el-form-item label="分配方式" prop="radio1">
        <el-radio-group v-model="form.radio1" v-if="tabType === 1" @change="changeRadio1">
          <el-radio :label="1" v-if="itemRow && itemRow.levelId!=1">直接转给上级</el-radio>
          <el-radio :label="2">指定分配</el-radio>
        </el-radio-group>
        <el-radio-group v-model="form.radio2" v-if="tabType === 2" @change="changeRadio2">
          <el-radio :label="1" v-if="itemRow && itemRow.levelId!=1">直接转给上级</el-radio>
          <el-radio :label="2">指定分配</el-radio>
        </el-radio-group>
        <el-radio-group v-model="form.radio3" v-if="tabType === 3" @change="changeRadio3">
          <el-radio :label="1" v-if="itemRow && itemRow.levelId!=1">直接转给上级</el-radio>
          <el-radio :label="2">指定分配</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="区域：" prop="areaDetail" required v-if="tabType === 1 && form.radio1 === 2">
        <div v-for="(item,index) in form.areaDetail" :key="index" class="full-box">
          <el-cascader v-model="item.districtCode" :props="cascaderProps" collapse-tags placeholder="请选择需要分配的区域" :options="options.technicianAreOptions" clearable></el-cascader>
          <el-select v-model="item.technicianInfoId" placeholder="请选择老师" clearable size="small" filterable :filter-method="technicalFilter" @blur="handleTechnical()">
            <el-option v-for="(it,index) in options.identityOptions" :key="it.id" :label="`${it.realName} (${it.mobile})`" :value="it.id"></el-option>
          </el-select>
          <div class="full-icon">
            <i class="el-icon-plus" @click="handleAddItem"></i>
            <i class="el-icon-minus" @click="handleDeleteItem(index)"></i>
          </div>
        </div>
      </el-form-item>

      <el-form-item label="团队：" prop="childDetail" required v-if="tabType === 2 && form.radio2 === 2">
        <!-- {{form.childDetail}} -->
        <div v-for="(item,index) in form.childDetail" :key="index" class="full-box">
          <el-select v-model="item.id" placeholder="请选择需要分配的团队" multiple collapse-tags clearable size="small">
            <el-option v-for="(it,index) in options.teamOptions" :key="it.id" :label="it.realName + '(' + it.levelName +')' + it.mobile" :value="it.id"></el-option>
          </el-select>
          <el-select v-model="item.parentId" placeholder="请选择老师" clearable size="small" filterable :filter-method="technicalFilter" @blur="handleTechnical()">
            <el-option v-for="(it,index) in options.identityOptions" :key="it.id" :label="`${it.realName} (${it.mobile})`" :value="it.id"></el-option>
          </el-select>
          <div class="full-icon">
            <i class="el-icon-plus" @click="handleAddTeam"></i>
            <i class="el-icon-minus" @click="handleDeleteTeam(index)"></i>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="客户：" prop="customerDetail" required v-if="tabType === 3 && form.radio3 === 2">
        <div v-for="(item,index) in form.customerDetail" :key="index" class="full-box">
          <el-select v-model="item.id" placeholder="请选择需要分配的客户" collapse-tags multiple clearable size="small">
            <el-option v-for="(it,index) in options.customerOptions" :key="it.id" :label="it.name" :value="it.id"></el-option>
          </el-select>
          <el-select v-model="item.technicianId" placeholder="请选择老师" clearable size="small" filterable :filter-method="technicalFilter" @blur="handleTechnical()">
            <el-option v-for="(it,index) in options.identityOptions" :key="it.id" :label="`${it.realName} (${it.mobile})`" :value="it.id"></el-option>
          </el-select>
          <div class="full-icon">
            <i class="el-icon-plus" @click="handleAddCustomer"></i>
            <i class="el-icon-minus" @click="handleDeleteCustomer(index)"></i>
          </div>
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false,tabType=1">取消</el-button>
      <el-button type="primary" @click="doCreate()" v-loading.fullscreen.lock="fullscreenLoading">{{tabType === 3?'确认离职':'下一步'}}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import technicianInfoApi from '@/api/technical/technicianInfo'
import technicianAreaApi from '@/api/technical/technicianArea'
import customerApi from '@/api/technical/customer'

function initFormBean() {
  const formBean = {
    radio1: null,
    radio2: null,
    radio3: null,
    areaDetail: [],
    childDetail: [],
    customerDetail: []
  }
  return formBean
}
function initFormBean2() {
  const formBean = [{
    id: 1,
    text: '分配区域'
  }, {
    id: 2,
    text: '分配团队'
  }, {
    id: 3,
    text: '分配客户'
  }, {
    id: 4,
    text: '确认离职'
  }]
  return formBean
}
export default {
  props: ['isServiceTeacher'],
  data() {
    return {
      userId: null,
      options: {
        technicalServiceLevel: [],
        identityOptions: [],
        technicianAreOptions: [],
        teamOptions: [],
        customerOptions: []

      },
      fullscreenLoading: false,
      form: initFormBean(),
      formVisible: false,
      formRules: {
        radio1: [{
          required: true,
          message: '请选择分配方式',
          trigger: 'change'
        }],
        radio2: [{
          required: true,
          message: '请选择分配方式',
          trigger: 'change'
        }],
        radio3: [{
          required: true,
          message: '请选择分配方式',
          trigger: 'change'
        }],
      },
      cascaderProps: {
        label: 'areaName',
        value: 'areaCode',
        children: 'child',
        multiple: true
      },
      itemRow: null,
      tabType: 1,
      ulList: initFormBean2()
    }
  },
  created() {

  },
  methods: {
    technicalFilter(e) {
      this.handleTechnical(e)
    },
    handleTechnical(val) {
      let obj = {
        status: 10,
        pageNo: 1,
        pageSize: 100,
        realName: val,
      }
      //status  10 已入职  20  离职交接  30 已离职
      technicianInfoApi.listPageForMini(obj).then(({
        data
      }) => {
        this.options.identityOptions = data.list.filter(i => i.userId != this.itemRow.userId)
      })
    },
    // 获取区域
    changeIdentity() {
      this.loading = this.$loading({
        lock: true,
        text: "加载中",
        background: "rgba(0, 0, 0, 0.7)",
      });
      technicianAreaApi.fetchTreeList({
        techInfoId: this.itemRow.id,
        parentTechInfoId: this.itemRow.parentId,
        addOrDelete: 2,
        v: 3,
        customerLeveId: this.itemRow.levelId
      }).then(({
        data
      }) => {
        this.loading.close()
        this.options.technicianAreOptions = this.formatCascaderData(data)
        this.formVisible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].clearValidate()
          this.form.radio1 = this.itemRow.levelId == 1 ? 2 : 1
          this.form.radio2 = this.itemRow.levelId == 1 ? 2 : 1
          this.form.radio3 = this.itemRow.levelId == 1 ? 2 : 1
          this.changeRadio1()
        })
      }).catch(() => {
        this.loading.close()
      })
    },

    formatCascaderData(data) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].child.length < 1) {
          // children若为空数组，则将children设为undefined
          data[i].child = undefined;
        } else {
          // children若不为空数组，则继续 递归调用 本方法
          this.formatCascaderData(data[i].child)
        }
      }
      return data
    },
    //指定分配 管辖区域
    changeRadio1() {
      let {
        radio1
      } = this.form;
      if (radio1 === 1) {
        this.$set(this.form, 'areaDetail', [])
      } else {
        this.form.areaDetail.push({
          districtCode: [],
          technicianInfoId: ''
        })
      }
    },
    handleDeleteItem(index) {
      // console.log('form.areaDetail: ',this.form.areaDetail.length);
      if (this.form.areaDetail.length <= 1) return
      this.form.areaDetail.splice(index, 1)
    },
    handleAddItem() {
      this.form.areaDetail.push({
        districtCode: [],
        technicianInfoId: ''
      })
    },
    //指定分配 团队
    getTeam() {
      technicianInfoApi.listForMini({
        parentId: this.itemRow.id,
        status: 10
      }).then(({
        data
      }) => {
        this.options.teamOptions = data
        if (!this.options.teamOptions.length) {
          let index = this.ulList.findIndex(i => i.id == 2)
          this.ulList.splice(index, 1)
        }
      })
    },
    changeRadio2() {
      let {
        radio2
      } = this.form;
      if (radio2 === 1) {
        this.$set(this.form, 'childDetail', [])
      } else {
        this.form.childDetail.push({
          id: [],
          parentId: ''
        })
      }
    },
    handleDeleteTeam(index) {
      if (this.form.childDetail.length <= 1) return
      this.form.childDetail.splice(index, 1)
    },
    handleAddTeam() {
      this.form.childDetail.push({
        id: [],
        parentId: ''
      })
    },
    //指定分配 客户
    getCustomer() {
      customerApi.listForMini({
        technicianId: this.itemRow.id
      }).then(({
        data
      }) => {
        this.options.customerOptions = data
        if (!this.options.customerOptions.length) {
          let index = this.ulList.findIndex(i => i.id == 3)
          this.ulList.splice(index, 1)
        }
      })
    },
    changeRadio3() {
      let {
        radio3
      } = this.form;
      if (radio3 === 1) {
        this.$set(this.form, 'customerDetail', [])
      } else {
        this.form.customerDetail.push({
          id: [],
          technicianId: ''
        })
      }
    },
    handleDeleteCustomer(index) {
      if (this.form.customerDetail.length <= 1) return
      this.form.customerDetail.splice(index, 1)
    },
    handleAddCustomer() {
      this.form.customerDetail.push({
        id: [],
        technicianId: ''
      })
    },
    /**
     * 重置表单
     */
    resetForm() {
      this.form = initFormBean()
      this.ulList = initFormBean2()
      this.tabType = 1
    },
    handleQuit(row) {
      // console.log('row-----: ', row,this.tabType);
      this.resetForm()
      this.handleTechnical()
      this.itemRow = {
        ...row
      }

      this.changeIdentity()
      this.getTeam()
      this.getCustomer()

    },
    calcParams() {
      let {
        radio1,
        radio2,
        radio3,
        areaDetail,
        childDetail,
        customerDetail
      } = this.form
      let params = {
        id: this.itemRow.id,
        areaDetail: [],
        childDetail: [],
        customerDetail: []
      }
      if (radio1 === 2) {
        let arr1 = []
        areaDetail && areaDetail.forEach(item => {
          item.districtCode.map(i => {
            arr1.push({
              districtCode: i[2],
              technicianInfoId: item.technicianInfoId
            })
          })
        })
        params.areaDetail = arr1
      }
      if (radio2 === 2) {
        let arr2 = []
        childDetail && childDetail.forEach(item => {
          item.id.map(i => {
            arr2.push({
              id: i,
              parentId: item.parentId
            })
          })
        })
        params.childDetail = arr2
      }
      if (radio3 === 2) {
        let arr3 = []
        params.customerDetail = customerDetail && customerDetail.forEach(item => {
          item.id.map(i => {
            arr3.push({
              id: i,
              technicianId: item.technicianId
            })
          })
        })
        if (this.isServiceTeacher) {
          params.customerDetailForBig = arr3
        } else {
          params.customerDetail = arr3
        }
      }
      console.log('areaList:----------- ', areaDetail);
      return params
    },
    doCreate() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          if (this.tabType == 1 && this.form.radio1 == 2) {
            let arrs = this.form.areaDetail.filter(item => !item.districtCode || !item.technicianInfoId)
            if (arrs.length) return this.$common.showMsg('warning', '请输入完整信息')
          }
          if (this.tabType == 2 && this.form.radio2 == 2) {
            let arrs = this.form.childDetail.filter(item => !item.id || !item.parentId)
            if (arrs.length) return this.$common.showMsg('warning', '请输入完整信息')
          }
          if (this.tabType == 3 && this.form.radio3 == 2) {
            let arrs = this.form.customerDetail.filter(item => !item.id || !item.technicianId)
            if (arrs.length) return this.$common.showMsg('warning', '请输入完整信息')
          }
          let params = this.calcParams();
          // console.log('params: ',params);
          // console.log('this.form.areaDetail222',this.form)
          if (this.tabType == 1 && !this.options.teamOptions.length && !this.options.customerOptions.length) {
            this.tabType = 3
          }
          if (this.tabType == 2 && !this.options.customerOptions.length) {
            this.tabType = 3
          }

          if (this.tabType === 3) {
            // let Ins = this.isServiceTeacher ? technicianInfoApi.transferForBig : technicianInfoApi.resignQuit
            this.$common.confirm('是否确认提交离职，离职后该老师无法享受技术老师权益').then(() => technicianInfoApi.resignQuit(params))
              .then(() => {
                this.fullscreenLoading = true;
                setTimeout(() => {
                  this.postCallback()
                }, 2000)
                // console.log('11111111');
              }).catch(() => {
                // console.log('22222');
                if (this.tabType == 3 && !this.options.teamOptions.length && !this.options.customerOptions.length) {
                  this.tabType = 1
                }
                if (this.tabType == 3 && !this.options.customerOptions.length) {
                  this.tabType = 2
                }
              });
          } else {
            if (this.tabType == 1 && !this.options.teamOptions.length) {
              this.tabType = this.tabType + 2
            } else {
              this.tabType++
            }
            if (this.tabType == 2) {
              this.changeRadio2()
            }
            if (this.tabType == 3) {
              this.changeRadio3()
            }
          }

        }
      });
    },
    postCallback(response) {
      this.tabType = 1

      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
      this.fullscreenLoading = false
    },
  }
}
</script>
<style lang="scss" scoped>
// .el-form-item--small.el-form-item {
//   width: 48%;
//   display: inline-block;
//   vertical-align: top;
// }
// .el-form-item--small.el-form-item.width100 {
//   width: 97%;
// }
::v-deep .el-select {
  width: 50%;
  margin-left: 5px;
}

::v-deep .el-cascader {
  width: 100%;
}

.input-box {
  display: flex;
  align-items: center;
}

.cssNav {
  display: flex;
  margin: 0 0 20px;

  li {
    // padding: 0px 74px;
    line-height: 40px;
    background: #eff8fd;
    display: inline-block;
    color: #1596cd;
    position: relative;
    display: flex;
    justify-content: center;

    &::after {
      content: '';
      display: block;
      border-top: 20px solid transparent;
      border-bottom: 20px solid transparent;
      border-left: 20px solid #eff8fd;
      position: absolute;
      right: -20px;
      top: 0;
      z-index: 10;
    }

    &::before {
      content: '';
      display: block;
      border-top: 20px solid #eff8fd;
      border-bottom: 20px solid #eff8fd;
      border-left: 20px solid #eff8fd;
      position: absolute;
      left: 0px;
      top: 0;
    }

    &:first-child {
      border-radius: 4px 0 0 4px;
      padding-left: 25px;

      &::before {
        display: none;
      }
    }

    &:last-child {
      border-radius: 0px 4px 4px 0px;
      padding-right: 25px;

      &::after {
        display: none;
      }
    }

    &.active {
      background-color: #5dbde7;
      color: #fff;

      &::after {
        border-left-color: #5dbde7;
      }

      &::before {
        border-top-color: #5dbde7;
        border-bottom-color: #5dbde7;
        border-left-color: #5dbde7;
      }
    }
  }
}

.cssNavEnd {
  border-radius: 0px 4px 4px 0px;
  padding-right: 25px;

  &::after {
    display: none;
  }
}

.full-box {
  display: flex;
  margin-bottom: 10px;

  .el-form-item {
    width: 100%;
  }

  .full-icon {
    display: flex;
    align-items: center;
    height: 32px;

    i {
      font-size: 18px;
      font-weight: bold;
      color: #5dbde7;
      cursor: pointer;
      padding-left: 5px;
    }
  }
}
</style>
